<template>
  <div v-if="!!phaseData">
    <div class="d-flex gap-8 align-end flex-wrap">
      <select-printing-template v-model="selectedTemplate" type="report" style="max-width: 400px" />
      <v-btn color="primary" :disabled="!report || report.length === 0" :loading="printing" @click="printPdf">
        Imprimir
      </v-btn>
    </div>
    <field-label class="mt-8" label="Anotações">
      <text-area
        :max-length="2000"
        v-model="phaseData.notes"
        :key="'notes' + phaseKey"
        :disabled="isFinishedAttendance"
      />
    </field-label>
    <field-label class="mt-8" label="CIDs e sintomas">
      <search-server-field
        v-model="phaseData.symptoms"
        multiple
        :path="'cid-symptom'"
        :disabled="isFinishedAttendance"
      />
    </field-label>
    <attendance-overview-dialog ref="overviewDialog" />
  </div>
</template>

<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import SearchServerField from '@/components/SearchServerField.vue'
import AttendanceOverviewDialog from '../../AttendanceOverviewDialog.vue'
import { createNamespacedHelpers } from 'vuex'
import { STATUS_FINISHED } from '@/constants/attendance'
import SelectPrintingTemplate from '@/components/PrintingTemplate/SelectPrintingTemplate.vue'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { TextArea, FieldLabel, SearchServerField, AttendanceOverviewDialog, SelectPrintingTemplate },
  extends: BasePhase,
  data() {
    return {}
  },
  computed: {
    ...attendanceGettersMap(['attendance', 'attendanceId']),
    isFinishedAttendance() {
      return this.attendance?.status === STATUS_FINISHED.value
    },
  },
  methods: {
    async printPdf() {
      try {
        this.printing = true
        const blob = await this.$api.printingTemplate.print({
          templateId: this.selectedTemplate.id,
          patientId: this.attendance.patient.id,
          text: this.report,
          extraText: this.references,
        })
        this.$util.downloadBlob(blob, 'relatório.pdf')
      } catch (error) {
        this.$root.error(error)
      } finally {
        this.printing = false
      }
    },
    async print() {
      await this.$refs.overviewDialog.openDialog(this.attendanceId)
      await this.$refs.overviewDialog.print()
      await this.$refs.overviewDialog.closeDialog()
    },
    getDefaultData() {
      const data = {
        symptoms: [],
        notes: null,
      }
      return data
    },
  },
}
</script>

<style scoped></style>
